import { RelVar, Ty } from '@cotera/era';

export const ENTITY_DEFINITIONS = RelVar.create({
  scope: '@@cotera-entities',
  name: 'DEFINITIONS',
  ty: {
    name: Ty.nn('string'),
    id: Ty.nn('string'),
  },
});

export const EVENT_CURSORS = RelVar.create({
  scope: '@@cotera-events',
  name: 'CURSORS',
  ty: {
    paused_at: 'timestamp',
    cotera_stable_id: Ty.nn('string'),
    entity_id: Ty.nn('string'),
    sink_id: Ty.nn('string'),
    event_stream_id: Ty.nn('string'),
    detected_at_time: Ty.nn('timestamp'),
  },
});

export const MANIFEST_EVENT_STREAM_SINKS = RelVar.create({
  scope: '@@cotera-manifest-event-streams',
  name: 'SINKS',
  ty: {
    entity_id: Ty.nn('string'),
    sink_id: Ty.nn('string'),
    event_stream_id: Ty.nn('string'),
    type: Ty.nn('string'),
  },
});

export const MANIFEST_EVENT_STREAMS = RelVar.create({
  scope: '@@cotera-manifest-event-streams',
  name: 'STREAMS',
  ty: {
    entity_id: Ty.nn('string'),
    event_stream_id: Ty.nn('string'),
  },
});
